interface RewardIconProps {
  size?: number;
  className?: string;
}

export const RewardIcon = ({ size = 14, className = '' }: RewardIconProps) => (
  <img
    src='/playcast-token.svg'
    alt=''
    width={size}
    height={size}
    className={`inline-block shrink-0 ${className}`}
    draggable={false}
  />
);

export const PointsBadge = ({
  balance,
  size = 'sm',
}: {
  balance: number;
  size?: 'sm' | 'md';
}) => {
  const fontSize = size === 'md' ? 13 : 12;
  const iconSize = fontSize;

  return (
    <span
      className='inline-flex shrink-0 items-center gap-1 font-semibold text-white'
      style={{
        padding: '3px 8px',
        borderRadius: 999,
        border: '1px solid rgba(255,255,255,0.15)',
        background: 'rgba(255,255,255,0.08)',
        fontSize,
      }}
    >
      <RewardIcon size={iconSize} />
      {balance.toLocaleString()}
    </span>
  );
};
